<template>
	<div class="w-full">
		<vs-row vs-justify="center">
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="4" vs-sm="12" class="text-left">
				<vs-select autocomplete
				class="selectExample mt-5 w-full px-2"
				v-model="questionsByPage[index].properties.default"
				:label="$t('MODULE.listInfo.whereisData')"
				@change="change_list(questionsByPage[index].properties.default)">
				    <vs-select-item :key="index" :value="item.value" :text="$t(`MODULE.${item.text}`)" v-for="(item, index) in opcionesDefault" />
				</vs-select>
			</vs-col>
		</vs-row>
		<h6 class="vs-input--label mb-3 mt-5" v-if="hasData">
			<span>
				{{$t('MODULE.listInfo.title')}}
			</span>
		</h6>
		<div v-if="hasData">
			<vs-row>
			  	<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="5" vs-sm="12">
			   		<vs-input class="w-full mx-1" :label="$t('MODULE.listInfo.nameLabel')" v-model="Label" :placeholder="$t('MODULE.listInfo.nameLabel')"/>
			  	</vs-col>
			  	<vs-col class="my-3 md:my-0" vs-type="flex" vs-justify="center" vs-align="center" vs-w="5" vs-sm="12">
			   		<vs-input class="w-full mx-1" :label="$t('MODULE.listInfo.keyCode')" v-model="Value" :placeholder="$t('MODULE.listInfo.keyCode')"/>
			  	</vs-col>
			  	<vs-col vs-type="flex" vs-justify="flex-end" vs-align="flex-end" vs-w="2">
			   		<vs-button class="w-full" color="success" type="border" @click="addItem()">{{$t('MODULE.listInfo.add')}}</vs-button>
			  	</vs-col>
			</vs-row>
		</div>
		<div class="mt-3" v-if="hasData">
			<ul class="list-optins">
				<li class="mb-5" v-for="(item, indexItem) in data" :key="indexItem">
					<vs-row>
						 <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="11">
						 	{{indexItem + 1}}
						 	<div class="mr-3 ml-3"></div>
						 	<div class="form-input w-full">
						 		<input type="text" class="option w-full" v-model="item.label">
						 	</div>
						 </vs-col>
						 <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
						 	<div class="closed" v-if="data.length > 1" @click="deleteOption(indexItem)">
						 		X
						 	</div>
						 </vs-col>
					</vs-row>
				</li>
			</ul>
		</div>
	</div>
</template>


<script type="text/javascript">
	import { mapState, mapMutations } from 'vuex';
	import { clasesQuestions } from '@/serviforms/designer/provider/clases-questions.js';
	import  { setQuestion } from '@/serviforms/designer/indexDB/logic.js';
	export default {
		props: ['index'],
		data() {
			return {
				Label: '',
				Value: '',
				opcionesDefault: [
					{
						value: 'local',
						text: 'listInfo.locale'
					},
					{
						value: 'datasource',
						text: 'listInfo.fromDataOrigin'
					}
				]
			}
		},
		methods: {
			...mapMutations('resource', ['CHANGE_QUESTION']),
            /**
             * Agrega items a la lista informativa.
             */
			addItem() {
				const data = {
                    label: this.Label,
                    value: this.Value
                }
                const dataQuestion = this.questionsByPage[this.index].data;
                this.questionsByPage[this.index].data = [...dataQuestion, data];
                this.Label = '';
                this.Value = '';
            },
            /**
             * Elimina un item de la lista informativa
             * @param {number} index - Posición del elemento dentro del array
             */
			deleteOption(index) {
				this.questionsByPage[this.index].data.splice(index,1);
			},
			change_list(typeList) {
				const { name, label } = this.question;
				const element = Object.values(clasesQuestions[this.typeForm]['informative']);
				const findFunc = element.find(({name}) => name === 'info');

				if(typeList === 'local') {
					const result = findFunc(name, label);
					this.changeQuestion(result);
					console.log('This is new Structure local ',result);
				}else {
					const result = findFunc(name, label, 'datasource');
					this.changeQuestion(result);
					console.log('This is new Structure datasource ',result);

				}
			},
			async changeQuestion(question) {
				const nameDad = this.question.name;
				// await deleteDependenceDad(nameDad);
				const payload = {
					index: this.index,
					question: question
				}
				this.CHANGE_QUESTION(payload);
				// await this.reorganizarIndex(nameDad);
				// await this.getCreatedDependencies();
				setQuestion();
			},
		},
		computed: {
			...mapState('resource',['questionsByPage', 'dataSidebar']),
			inputType() {
				return this.questionsByPage[this.index].inputType;
			},
			question() {
				return this.questionsByPage[this.index];
			},
			hasData() {
				return this.questionsByPage[this.index].data?true:false;
			},
			data: {
				get() {
					return this.questionsByPage[this.index].data;
				}
			},
			typeForm() {
				if(this.dataSidebar.isSubForm === '0' || this.dataSidebar.isSubForm === false) return 'standar';
				if(this.dataSidebar.isSubForm === '1') return 'suform';
				if(this.dataSidebar.isSubForm === '2') return 'bot';
			},
		}

	}
</script>

<style type="text/css" lang="scss">
	$pimary: rgb(56,189,170);
	.list-optins {
		li {
			.addOption{
				color: #{$pimary};
				cursor:  pointer;
			}
			.radio{
				border-radius: 50%;
				width: 23px;
				height: 23px;
				border: 2px solid #D8D8D8;
			}

			.option {
				border: none;
				border-bottom: 1px solid #000000;
				height: 35px;
				font-size: 16px;
				// text-transform: lowercase;
				&:focus{
					border-bottom-color: #{$pimary};
				}
			}

			.closed {
				padding: 10px 15px;
				border-radius: 50%;
				font-size: 18px;
				font-weight: bold;
				cursor: pointer;
				&:hover{
					background: #F2F2F2;
				}
			}
		}
	}
</style>
